<template>
  <div>
    <p>
      <help-tooltip type="error">
        Unrecognized node component found.
      </help-tooltip>
      Stale data in use in this node, this may cause the case 
      not to load with newer versions of the Simulation.
    </p>
    <div> Data: {{ data }} </div>
  </div>
</template>

<script>
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'unknown-control',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
    data() {
      return this.getData(this.ikey);
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style>
</style>
